import React, { useEffect } from 'react';
import BudgetStylePicker from '../BudgetStylePicker';

export function useAppSelectDismiss(setOpen) {
  useEffect(() => {
    const onPick = (event) => {
      setOpen((current) => (current && current !== event.detail ? '' : current));
    };
    const onDoc = (event) => {
      if (!event.target.closest('.dropdown-container')) setOpen('');
    };
    window.addEventListener('pc-calc-picker', onPick);
    document.addEventListener('mousedown', onDoc);
    return () => {
      window.removeEventListener('pc-calc-picker', onPick);
      document.removeEventListener('mousedown', onDoc);
    };
  }, [setOpen]);
}

export default function AppSelect({
  id,
  open,
  setOpen,
  value,
  placeholder,
  searchPlaceholder,
  options,
  onSelect,
  layout = 'inline',
  disabled = false,
  menuClassName = 'w-[500px]',
}) {
  if (disabled) {
    return (
      <input className="pc-calc-select" value={value || ''} placeholder={placeholder} disabled readOnly />
    );
  }
  return (
    <BudgetStylePicker
      open={open}
      onOpen={() => {
        window.dispatchEvent(new CustomEvent('pc-calc-picker', { detail: id }));
        setOpen(id);
      }}
      displayValue={value || ''}
      placeholder={placeholder}
      searchPlaceholder={searchPlaceholder}
      options={options}
      onSelect={(selected) => {
        onSelect(selected);
        setOpen('');
      }}
      layout={layout}
      inputClassName="pc-calc-select"
      menuClassName={menuClassName}
    />
  );
}
